module.exports = __webpack_public_path__ + "media/images/common/ui/btn_dokanto_4two-8874457290429ded482bfd6518330a86.png";